// @flow
import type {
  AuthState,
} from '../types'

import initialAuthState from 'fc-auth/src/initialState'

export default ({
  ...initialAuthState,
  loginOperation: null,
  requestResetOperation: null,
  resetPasswordOperation: null,
  eulaSigned: false,
  isFetchingEulaSigned: true,
}: AuthState)
